import _ from 'underscore'
import ResultView from '../../../views/result'

const FrpResultView = ResultView.extend({
    initialize(options) {
        this.template = _.template(`
            <td><%- name %></td>
            <td><%- stars %></td>
            <td><%- completed %></td>
            <td style="background:<%- !fluency_total ? 'none' : (fluency_score / fluency_total < .5 ? 'red' : (fluency_score / fluency_total < .8 ? 'orange' : 'green')) %>">
                <div class="percentage-wrap">
                    <%- fluency_total ? Math.round(fluency_score / fluency_total * 100) + "%" : "-" %>
                </div>
            </td>
            <td style="background:<%- !reasoning_total ? 'none' : (reasoning_score / reasoning_total < .5 ? 'red' : (reasoning_score / reasoning_total < .8 ? 'orange' : 'green')) %>">
                <div class="percentage-wrap">
                    <%- reasoning_total ? Math.round(reasoning_score / reasoning_total * 100) + "%" : "-" %>
                </div>
            </td>
            <td style="background:<%- !problem_total ? 'none' : (problem_score / problem_total < .5 ? 'red' : (problem_score / problem_total < .8 ? 'orange' : 'green')) %>">
                <div class="percentage-wrap">
                    <%- problem_total ? Math.round(problem_score / problem_total * 100) + "%" : "-" %>
                </div>
            </td>
            <td style="background:<%- !total ? 'none' : (score / total < .5 ? 'red' : (score / total < .8 ? 'orange' : 'green')) %>">
                <div class="percentage-wrap">
                    <%- total ? Math.round(score / total * 100) + "%" : "-" %>
                </div>
            </td>
        `)

        this.dateFrom = options.dateFrom
        this.user = options.user

        // for when the app is purchased
        this.listenTo(this.model, 'change', this.render)
        // for when the ReportingView changes dateFrom value
        this.listenTo(this.dateFrom, 'change', this.resultsUpdated)
        // for when the ResultList.requestResults is fired
        this.listenTo(this.user.get('results'), 'add', this.resultsUpdated)

        // load locally saved results
        this.loadResults()
    },
    render() {
        this.$el.html(this.template({
            name: this.model.get('name'),
            purchased: this.model.get('purchased'),
            free: this.model.get('free'),
            stars: this.sum('star'),
            completed: this.results.length,
            score: this.sum('score'),
            total: this.sum('total'),
            fluency_score: this.sum('fluency_score'),
            fluency_total: this.sum('fluency_total'),
            reasoning_score: this.sum('reasoning_score'),
            reasoning_total: this.sum('reasoning_total'),
            problem_score: this.sum('problem_score'),
            problem_total: this.sum('problem_total'),
        }))
        return this
    },
})

export default FrpResultView
